import { API_BASE } from "./constants";
import { fetchJson } from "./fetch-json";

export type {
  SearchResult, BrandProfile, TickerResult, CryptoResult,
  BlockchainResult, EnsResult, GitHubResult, StatsResult,
} from '@/schemas/api-responses';

import type { SearchResult, BrandProfile, TickerResult, CryptoResult, StatsResult, EnsResult, BlockchainResult, GitHubResult } from '@/schemas/api-responses';

export async function searchBrands(query: string): Promise<SearchResult[]> {
  return fetchJson(`${API_BASE}/search?q=${encodeURIComponent(query)}`);
}

export async function describeBrand(domain: string): Promise<BrandProfile> {
  return fetchJson(`${API_BASE}/describe/${domain}`);
}

export async function lookupTicker(symbol: string): Promise<TickerResult> {
  return fetchJson(`${API_BASE}/ticker/${symbol.toUpperCase()}`);
}

export async function lookupCrypto(symbol: string): Promise<CryptoResult> {
  return fetchJson(`${API_BASE}/crypto/${symbol.toLowerCase()}`);
}

export async function fetchStats(): Promise<StatsResult> {
  return fetchJson(`${API_BASE}/stats`);
}

export async function lookupEns(name: string): Promise<EnsResult> {
  return fetchJson(`${API_BASE}/ens/${encodeURIComponent(name)}`);
}

export async function lookupBlockchain(id: string): Promise<BlockchainResult> {
  return fetchJson(`${API_BASE}/blockchain/${encodeURIComponent(id)}`);
}

export async function lookupGitHub(username: string): Promise<GitHubResult> {
  return fetchJson(`${API_BASE}/github/${encodeURIComponent(username)}`);
}
